import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { KeyStore } from '../engine/helpers/KeyStore';
import { buildScheduledBroadcast, useAddScheduledBroadcast, useScheduledBroadcasts, } from '../state/scheduleState';
import { useSetStreamDirectionCallback } from '../state/streamState';
import { generateStreamId, getStreamPathname } from '../utils/url';
export function useGoLiveNow() {
    const setStreamDirection = useSetStreamDirectionCallback();
    const addBroadcast = useAddScheduledBroadcast();
    const navigate = useNavigate();
    const broadcasts = useScheduledBroadcasts();
    return useCallback((options = {}) => {
        const { streamId, saveBroadcast } = options;
        const finalStreamId = streamId || generateStreamId();
        const keyStore = KeyStore.getInstance();
        // Save broadcast for later access
        if (saveBroadcast) {
            addBroadcast(buildScheduledBroadcast({
                name: 'Broadcast',
                startsAt: new Date().getTime(),
                streamId: finalStreamId,
                aesKey: keyStore.getAesKey(finalStreamId),
                publicKey: keyStore.getPublicKey(finalStreamId),
            }));
        }
        const broadcast = broadcasts.find((broadcast) => broadcast?.streamId === finalStreamId);
        setStreamDirection(finalStreamId, 'outgoing');
        navigate(getStreamPathname(finalStreamId, {
            broadcastStartsAt: broadcast?.startsAt,
            broadcastTitle: broadcast?.name,
        }));
    }, [navigate, setStreamDirection, addBroadcast, broadcasts]);
}
